import { makeStyles } from "@material-ui/core"

import { colors } from "@/styles/colors"

type StylesProps = {
	isMFAActive: boolean
}

const useStyles = makeStyles(() => ({
	deviceName: {
		fontSize: 14,
		textTransform: "capitalize",
		color: colors.gray[700],
		fontWeight: "bold",
		lineHeight: "12px"
	},
	localizationText: {
		fontSize: 10,
		textTransform: "capitalize",
		color: colors.gray[400],
		fontWeight: "normal"
	},
	disabledIcon: {
		width: 16,
		height: 16,
		color: colors.gray[700],
		opacity: 0.5,
		marginRight: 10
	},
	infoText: {
		opacity: 0.5,
		fontSize: 14
	},
	deviceItem: {
		background: colors.gray[100],
		opacity: 0.8,
		borderRadius: 8,
		width: 64,
		height: 64,
		color: colors.gray[700],
		display: "flex",
		alignItems: "center",
		justifyContent: "center"
	},
	mfaIcon: (props: StylesProps) => ({
		width: 12,
		height: 14,
		color: props.isMFAActive ? colors.blue[600] : colors.gray[400]
	})
}))

export default useStyles
